import React from 'react';
import cn from 'classnames';

import ButtonWithExtraAction from '@components/common/ButtonWithExtraAction';

import { ICompareButtonsTypes } from './CompareButtons.types';

import './CompareButtons.scss';

const CompareButtons = ({
	openCompareModal,
	clearCompare,
	isDisabledCompare,
	countOfCompareCharts,
	clearCorrelate,
	countOfCorrelateCharts,
	isDisabledCorrelate,
	openCorrelateModal,
	classNameCompareSection,
}: ICompareButtonsTypes) => (
	<div className={cn('f5gCompareButtonsContainer', { [`${classNameCompareSection}`]: !!classNameCompareSection })}>
		{!!countOfCompareCharts
			&& <ButtonWithExtraAction
				count={countOfCompareCharts}
				disableTooltip='Add 2 or 3 charts for comparison'
				isDisabled={isDisabledCompare}
				label='Compare selected'
				onClear={clearCompare}
				onClick={openCompareModal}
			/>
		}
		{!!countOfCorrelateCharts
			&& <ButtonWithExtraAction
				count={countOfCorrelateCharts}
				disableTooltip='Add 2 charts for correlation'
				isDisabled={isDisabledCorrelate}
				label='Correlate selected'
				onClear={clearCorrelate}
				onClick={openCorrelateModal}
			/>
		}
	</div>
);

export default CompareButtons;
